import { reactive, toRefs } from 'vue';
import PaymentApi from '../api/Payment';
import VippsStore from './vippsStore';

const initialState = {
    loading: false,
    displayPaymentMethods: true,
    paymentStatusCompleted: false,
    paymentMethod: null,
    studentKID: null,
    accountNumber: null,
    transactionFee: 1.95,
    sum: 0,
    max_sum: 0,
    sumIncludingFee: 0,
    phoneNumbers: [],
    phoneSelected: null,
    errorMessage: '',
    successMessage: '',
    qr_code: null,
    orderId: null,
    accountSummary: {
        totalSaleAmount: 0,
        totalPaymentAmount: 0,
        displayReservations: false,
        totalReservationAmount: 0,
        totalPackageAmount: 0,
        amountLabel: '',
        totalBalanceAmount: 0,
        hasNegativeBalance: true,
        not_invoiced_lines: [],
        not_invoiced_amount_formatted: '',
        not_invoiced_amount: 0,
    },
    accountOrderHistoryId: null,
    accountOrderHistory: {
        id: null,
        order_label: '',
        order_number: null,
        amount: 0,
        amount_formatted: '',
        amount_due: 0,
        amount_due_formatted: '',
        order_date: '',
        order_due_date: '',
        paid_amount: 0,
        paid_amount_formatted: '',
    },
    isStrictInvoicing: false,
    payInvoiceableLines: false,
    paymentMethods: {
        vipps: false,
        swish: false,
        card: false,
        nettbank: false,
    },
    optima: false,
    officeName: null,
    isLocalEnvironment: false,
    netsEasyUseProdEndpoint: true,
    hasBookingTerms: false,
};

const state = reactive({ ...initialState });

export default {
    state: toRefs(state),
    init() {
        this.setLoading(true);
        return PaymentApi.GetMethods(state.accountOrderHistoryId, state.payInvoiceableLines).then(res => {
            this.setLoading(false);
            if (res.success) {
                if (state.accountOrderHistoryId) {
                    this.setAccountOrderHistory(res.data.accountOrderHistory);
                    if (res.data.accountOrderHistory === null) {
                        return;
                    }
                }
                console.log('accountDetails', res.data.accountDetails);
                this.setAccountSummary(res.data.accountDetails);
                this.setPaymentMethods(res.data.paymentMethods);
                this.setResponseData(res.data);
                state.phoneNumbers = res.data.phoneNumbers;
                this.setVippsMobile(res.data.phoneNumbers[0]);
                state.officeName = res.data.officeName;
                state.optima = res.data.optima;
                state.isLocalEnvironment = res.data.isLocalEnvironment;
                state.netsEasyUseProdEndpoint = res.data.netsEasyUseProdEndpoint !== false;
                state.hasBookingTerms = res.data.hasBookingTerms;
            } else {
                this.handleLoadingError(res);
            }
        }).catch(e => {
            this.handleLoadingError(e);
        });
    },
    setOrderId(orderId) {
        console.log('setOrderId', orderId);
        state.orderId = orderId;
    },
    getOrderId() {
        return state.orderId
    },
    handleLoadingError(e) {
        this.setErrorMessage($t('Det skjedde noe galt. Prøv igjen senere.'));
        this.setLoading(false);
        console.error(e);
    },
    submitVipps() {
        if (this.getLoading()) return;

        this.setLoading(true);
        this.setDisplayPaymentMethods(false);
        const _this = this;

        PaymentApi.PostVipps({
            mobile: state.phoneSelected,
            sum: state.sum,
            v2: true
        }).then(res => {
            if (res.success) {
                if (res.data.message) {
                    if (res.data.isApp) {
                        _this.setLoading(false);
                        window.location = res.data.message;
                        return;
                    }
                    this.setSuccessMessage('Du videresendes nå til Vipps...');
                    setTimeout(function () {
                        _this.setLoading(false);
                        window.location = res.data.message;
                    }, 2000);
                    return;
                }
                this.setLoading(false);
                this.setPaymentMethod(null);
                VippsStore.init(res.data);
            } else {
                this.setLoading(false);
                this.setDisplayPaymentMethods(true);
                if (res.message) {
                    this.setErrorMessage(res.message);
                } else {
                    this.setErrorMessage($t('Det skjedde noe galt. Prøv igjen senere.'));
                }
            }
        }).catch(e => {
            this.setLoading(false);
            this.setDisplayPaymentMethods(true);
            this.handleLoadingError(e);
        });
    },
    submitSwish() {
        if (this.getLoading()) return;

        this.setLoading(true);
        this.setDisplayPaymentMethods(false);

        PaymentApi.PostSwish({
            mobile: state.phoneSelected,
            sum: state.sum,
            accountOrderHistoryId: state.accountOrderHistoryId,
            payInvoiceableLines: state.payInvoiceableLines,
        }).then(res => {
            this.postSwishCallback(res);
        }).catch(e => {
            this.setDisplayPaymentMethods(true);
            this.handleLoadingError(e);
        }).finally(() => {
            this.setLoading(false);
        });
    },
    postSwishCallback(res) {
        if (res.success) {
            if (res.data.transaction) {
                state.orderId = res.data.transaction;
            }

            if (res.data.redirect) {
                this.setLoading(false);
                window.location = res.data.message;
                return;
            }

            if (res.data.qr_code) {
                state.qr_code = res.data.qr_code;
            }
        } else {
            this.setDisplayPaymentMethods(true);
            if (res.message) {
                this.setErrorMessage(res.message);
            } else {
                this.setErrorMessage($t('Det skjedde noe galt. Prøv igjen senere.'));
            }
        }
    },
    submitCard() {
        if (this.getLoading()) return;

        this.setLoading(true);
        this.setDisplayPaymentMethods(false);

        PaymentApi.PostCard({
            mobile: state.phoneSelected,
            sum: state.sum,
            accountOrderHistoryId: state.accountOrderHistoryId,
            payInvoiceableLines: state.payInvoiceableLines,
        }).then(res => {
            if (res.success) {
                if (res.data.transaction) {
                    state.orderId = res.data.transaction;
                    const checkoutOptions = {
                        checkoutKey: res.data.netsEasyCheckoutKey,
                        paymentId: res.data.paymentId,
                        containerId: "checkout-container-div",
                        language: "sv-SE",
                    };
                    const checkout = new Dibs.Checkout(checkoutOptions);
                    checkout.on('payment-completed', function (response) {
                        PaymentApi.PaymentInProgress(response['paymentId']);
                    });
                }
            } else {
                this.setDisplayPaymentMethods(true);
                if (res.message) {
                    this.setErrorMessage(res.message);
                } else {
                    this.setErrorMessage($t('Det skjedde noe galt. Prøv igjen senere.'));
                }
            }
        }).catch(e => {
            this.setDisplayPaymentMethods(true);
            this.handleLoadingError(e);
        }).finally(() => {
            this.setLoading(false);
        });
    },
    setLoading(val) {
        state.loading = val;
    },
    setPaymentMethod(method) {
        console.log(method)
        if (this.getPaymentMethods()[method] === true || method === null) {
            console.log(state.paymentMethod)
            state.paymentMethod = method;
        }
    },
    setAccountOrderHistoryId(id) {
        state.accountOrderHistoryId = id;
    },
    setIsStrictInvoicing(val) {
        state.isStrictInvoicing = val;
    },
    setPayInvoiceableLines(val) {
        state.payInvoiceableLines = val;
    },
    isStrictInvoicing() {
        return state.isStrictInvoicing;
    },
    payInvoiceableLines() {
        return state.payInvoiceableLines;
    },
    setAccountOrderHistory(accountOrderHistory) {
        if (accountOrderHistory === null) {
            this.setAccountOrderHistoryId(null);
            this.setErrorMessage($t("Ugyldig betalingsgrunnlag. Naviger til kontoen og prøv igjen."));
            return;
        }
        state.accountOrderHistory.id = accountOrderHistory.id;
        state.accountOrderHistory.order_label = accountOrderHistory.order_label;
        state.accountOrderHistory.order_number = accountOrderHistory.order_number;
        state.accountOrderHistory.amount = accountOrderHistory.amount;
        state.accountOrderHistory.amount_formatted = accountOrderHistory.amount_formatted;
        state.accountOrderHistory.amount_due = accountOrderHistory.amount_due;
        state.accountOrderHistory.amount_due_formatted = accountOrderHistory.amount_due_formatted;
        state.accountOrderHistory.paid_amount = accountOrderHistory.paid_amount;
        state.accountOrderHistory.paid_amount_formatted = accountOrderHistory.paid_amount_formatted;
        state.accountOrderHistory.order_date = accountOrderHistory.order_date;
        state.accountOrderHistory.order_due_date = accountOrderHistory.order_due_date;
    },
    setAccountSummary(account) {
        if (state.payInvoiceableLines) {
            state.accountSummary.not_invoiced_amount_formatted = account.not_invoiced_amount_formatted;
            state.accountSummary.not_invoiced_amount = account.not_invoiced_amount;
            state.accountSummary.not_invoiced_lines = account.not_invoiced_lines;
            state.sum = account.not_invoiced_amount;
            return;
        }
        state.accountSummary.amountLabel = account.amountLabel;
        state.accountSummary.totalSaleAmount = account.totalSaleAmount;
        state.accountSummary.totalPaymentAmount = account.totalPaymentAmount;
        state.accountSummary.displayReservations = account.displayReservations;
        state.accountSummary.totalReservationAmount = account.totalReservationAmount;
        state.accountSummary.totalPackageAmount = account.totalPackageAmount;
        state.accountSummary.totalBalanceAmount = account.totalBalanceAmount;
        state.accountSummary.hasNegativeBalance = account.hasNegativeBalance;
        const absoluteMax = 20000;
        state.max_sum = absoluteMax;
        if (account.hasNegativeBalance) {
            this.setSum(account.totalBalanceAmount > absoluteMax ? absoluteMax : account.totalBalanceAmount);
        }
    },
    setPaymentMethods(paymentMethods) {
        state.paymentMethods.vipps = paymentMethods.vipps;
        state.paymentMethods.swish = paymentMethods.swish;
        state.paymentMethods.card = paymentMethods.card;
        state.paymentMethods.nettbank = paymentMethods.nettbank;
    },
    setResponseData(data) {
        state.transactionFee = data.transactionFee;
        state.accountNumber = data.accountNumber;
        if (data.studentKID) {
            state.studentKID = data.studentKID;
        }
    },
    setSum(amount) {
        if (isNaN(parseInt(amount))) {
            state.sum = 0;
            state.sumIncludingFee = 1;
            return;
        }

        state.sum = Math.floor(amount);
        let fee = state.sum * state.transactionFee / 100;
        if (fee < 1) {
            fee = 1;
        }
        state.sumIncludingFee = Math.round(state.sum + fee);
    },
    setVippsMobile(phone) {
        if (state.phoneNumbers.indexOf(phone) !== -1) {
            state.phoneSelected = phone;
        }
    },
    setErrorMessage(message) {
        state.errorMessage = message;
        clearTimeout(state.clearErrorMessageTimeout);
        const _this = this;
        state.clearErrorMessageTimeout = setTimeout(function () {
            state.errorMessage = '';
        }, 10000);
    },
    setSuccessMessage(message) {
        state.successMessage = message;
        clearTimeout(state.clearSuccessMessage);
        state.clearSuccessMessage = setTimeout(function () {
            state.successMessage = '';
        }, 10000);
    },
    setDisplayPaymentMethods(val) {
        state.displayPaymentMethods = val;
    },
    setPaymentStatusComplete() {
        state.paymentStatusCompleted = true;
    },
    getPaymentMethod() {
        return state.paymentMethod;
    },
    getLoading() {
        return state.loading;
    },
    getOfficeName() {
        return state.officeName;
    },
    getPaymentMethods() {
        return state.paymentMethods;
    },
    getAccountSummary() {
        return state.accountSummary;
    },
    getSaleAmount() {
        return state.accountSummary.totalSaleAmount;
    },
    getPaymentAmount() {
        return state.accountSummary.totalPaymentAmount;
    },
    getDisplayReservations() {
        return state.accountSummary.displayReservations;
    },
    getReservationsAmount() {
        return state.accountSummary.displayReservations;
    },
    getBalanceAmountLabel() {
        if (state.accountOrderHistoryId) {
            return $t('Skyldig');
        }
        return state.accountSummary.amountLabel;
    },
    getBalanceAmount() {
        return state.accountSummary.totalBalanceAmount;
    },
    getPackageAmount() {
        return state.accountSummary.totalPackageAmount;
    },
    getHasNegativeBalance() {
        return state.accountSummary.hasNegativeBalance;
    },
    getStudentKID() {
        return state.studentKID;
    },
    getAccountNumber() {
        return state.accountNumber;
    },
    getTransactionFee() {
        return state.transactionFee;
    },
    getSum() {
        return state.sum;
    },
    getMaxSum() {
        return state.max_sum;
    },
    getSumIncludingFee() {
        return state.sumIncludingFee;
    },
    getMobileNumbers() {
        return state.phoneNumbers;
    },
    getDisplayPaymentMethods() {
        return state.displayPaymentMethods;
    },
    getErrorMessage() {
        return state.errorMessage;
    },
    getSuccessMessage() {
        return state.successMessage;
    },
    isLocalEnvironment() {
        return state.isLocalEnvironment;
    },
    netsEasyUseProdEndpoint() {
        return state.netsEasyUseProdEndpoint;
    },
    getPaymentStatusCompleted() {
        return state.paymentStatusCompleted
    },
    getAccountOrderHistoryId() {
        return state.accountOrderHistoryId;
    },
    getAccountOrderHistory() {
        return state.accountOrderHistory;
    },
    getQrCode() {
        return state.qr_code;
    },
    hasBookingTerms() {
        return state.hasBookingTerms
    },
};
